/*

<LockerSelectorInMap
    list={lockerList}
    idSelected={this.state.lockerId}
    handleChange={x=>this.setState({lockerId: x})}

    // optional doorSize
    doorSizeName='XL'
    handleDoorSizeClick={this.calculate}
/>

 */
import React from 'react'
import SelectSimple from './selectSimple'
import Map from '../map'
import { RESOURCES_URL } from '../../server/connection'
import MarkerSelectedIcon from '../../assets/icons/LockerMarkerSelected.png'
import FormLabel from '@material-ui/core/FormLabel/FormLabel'
import { strings } from '../../localization/strings'
import EditIcon from '@material-ui/icons/Edit'
import { IconButton } from '@material-ui/core'
const getResourceUrl = (key) => RESOURCES_URL + 'Resource/get?key=' + key
const markerIcon = getResourceUrl('LockerMarker')
const markerSelectedIcon = MarkerSelectedIcon

const mapZoom = 13

const Component = ({
    list,
    handleChange,
    idSelected,
    doorSizeName,
    handleDoorSizeClick,
}) => {
    if (!list || !list.length) return null

    let mapData = {
        options: {
            zoom: mapZoom,
            center: { lat: list[0].latitude, lng: list[0].longitude },
        },
        markers: [],
    }

    list.forEach((locker) => {
        mapData.markers.push({
            options: {
                markerId: locker.lockerId,
                icon:
                    locker.lockerId === idSelected
                        ? markerSelectedIcon
                        : markerIcon,
                position: { lat: locker.latitude, lng: locker.longitude },
            },
        })
    })

    const forSelect = list.map((x) => ({
        value: x.lockerId,
        labelForFilter: x.lockerName + ' - ' + x.address,
        label: (
            <div style={{ whiteSpace: 'initial' }}>
                <div
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {x.lockerName}
                </div>
                <div style={{ fontSize: '75%', margin: 0, marginTop: 4 }}>
                    <div
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {x.address}
                    </div>
                </div>
                <div style={{ fontSize: '75%', margin: 0, marginTop: 4 }}>
                    {!x.lockerLocationDetails ? '' : x.lockerLocationDetails}
                </div>
                <div style={{ fontSize: '70%', margin: 0, marginTop: 4 }}>
                    {!x.city ? '' : x.city + ', ' + (x.province || '')}
                </div>
            </div>
        ),
    }))

    return (
        <div
            style={{ border: '2px solid #f7b500', borderRadius: 8, padding: 8 }}
        >
            {!doorSizeName ? null : (
                <FormLabel
                    component="legend"
                    style={{ display: 'flex', alignItems: 'center' }}
                >
                    {strings.reverseLogisticsLockersTitle}
                    <div
                        style={{
                            padding: '0px 10px',
                            fontSize: '150%',
                            fontWeight: 'bolder',
                        }}
                    >
                        {doorSizeName}
                    </div>
                    <IconButton color={'primary'} onClick={handleDoorSizeClick}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                </FormLabel>
            )}

            <SelectSimple
                options={forSelect}
                selectedOption={forSelect.find((x) => x.value === idSelected)}
                handleChange={(x) => handleChange(x.value)}
                inputHeight={128}
                labelForFilter={'labelForFilter'}
            />

            <div style={{ marginTop: 20 }} />

            <Map
                style={{ height: 285 }}
                id="map-locker-map"
                mapData={mapData}
                visible={true}
                handleMarkerOnClick={(x) => handleChange(x)}
                markerSelectedId={idSelected}
                fitBounds={true}
            />
        </div>
    )
}

export default Component
